import { render } from "./DraggableStack.vue?vue&type=template&id=01ed75fe&scoped=true"
import script from "./DraggableStack.vue?vue&type=script&lang=js"
export * from "./DraggableStack.vue?vue&type=script&lang=js"

import "./DraggableStack.vue?vue&type=style&index=0&id=01ed75fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ed75fe"]])

export default __exports__